import { ISubscription } from 'src/interfaces/subscription';
import { IStore } from 'src/interfaces/store';
import {
    GET_STORES,
    CREATE_STORE,
    GET_STORE,
    DELETE_STORE,
    UPDATE_STORE,
    SET_ERROR,
    CLEAR_STATE,
    SET_LOADING,
    GET_STORES_BY_MAKE,
    GET_ALL_STORES,
    UPDATE_ALL_STORES,
    UPDATE_ATTRIBUTES_STORES,
    GET_SUBSCRIPTIONS,
    CLEAR_SNACKBARS,
    CLEAR_ERRORS,
    ADD_SUBSCRIPTION,
    ADD_SUBSCRIPTION_CREDITS,
    GET_STORE_INTEGRATIONS_START,
    GET_STORE_INTEGRATIONS_SUCCESS,
    GET_STORE_INTEGRATIONS_ERROR,
    REFRESH_STORE_INTEGRATIONS_START,
    REFRESH_STORE_INTEGRATIONS_SUCCESS,
    REFRESH_STORE_INTEGRATIONS_ERROR,
} from '../types';
import {
    TAction,
    TInitialState,
    TRefreshExpirationsResult,
    TStoreIntegration,
} from './types';

export default (state: TInitialState, action: TAction) => {
    switch (action.type) {
        case GET_STORE_INTEGRATIONS_START:
            return {
                ...state,
                storeIntegrationsLoading: true,
                storeIntegrationsError: null,
            };
        case GET_STORE_INTEGRATIONS_SUCCESS:
            return {
                ...state,
                storeIntegrations: action.payload as TStoreIntegration[],
                storeIntegrationsLoading: false,
                storeIntegrationsError: null,
            };
        case GET_STORE_INTEGRATIONS_ERROR:
            return {
                ...state,
                storeIntegrationsLoading: false,
                storeIntegrationsError: action.payload as string,
            };
        case REFRESH_STORE_INTEGRATIONS_START:
            return {
                ...state,
                storeIntegrationsRefreshing: true,
                storeIntegrationsError: null,
                storeIntegrationsRefreshResult: null,
            };
        case REFRESH_STORE_INTEGRATIONS_SUCCESS:
            return {
                ...state,
                storeIntegrationsRefreshing: false,
                storeIntegrationsRefreshResult:
                    action.payload as TRefreshExpirationsResult,
            };
        case REFRESH_STORE_INTEGRATIONS_ERROR:
            return {
                ...state,
                storeIntegrationsRefreshing: false,
                storeIntegrationsError: action.payload as string,
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                success: null,
            };
        case CLEAR_SNACKBARS:
            return { ...state, success: null, error: null };
        case ADD_SUBSCRIPTION_CREDITS:
            let currentSubscriptions = state?.subscriptions || [];
            currentSubscriptions = currentSubscriptions.filter(
                (subscription: ISubscription) =>
                    String(subscription._id) !==
                    String((action.payload as ISubscription)._id)
            );

            const newSubscription = [
                ...currentSubscriptions,
                action.payload as ISubscription,
            ];

            return {
                ...state,
                subscriptions: newSubscription,
            };
        case ADD_SUBSCRIPTION:
            return {
                ...state,
                subscriptions: [
                    ...(state?.subscriptions || []),
                    action.payload,
                ],
                loading: false,
                error: null,
            };
        case UPDATE_ATTRIBUTES_STORES:
            let storesChanged: IStore[] = [];
            if (state && state.stores) {
                storesChanged = state.stores.map((item: IStore) => {
                    return {
                        ...item,
                        ...(action.payload as Partial<IStore>),
                    };
                });
            }
            return {
                ...state,
                stores: storesChanged,
            };
        case GET_SUBSCRIPTIONS:
            return {
                ...state,
                subscriptions: action.payload,
                loading: false,
            };
        case UPDATE_ALL_STORES:
            let aux: IStore[] = [];
            if (state && state.allStores) {
                state.allStores.map((store: IStore) => {
                    if (!Array.isArray(action.payload)) {
                        if (store._id === (action.payload as IStore)._id)
                            aux.push(action.payload as IStore);
                        else aux.push(store);
                    }
                    return false;
                });
            }
            return {
                ...state,
                allStores: aux,
                loading: false,
            };
        case GET_ALL_STORES:
            return {
                ...state,
                allStores: action.payload,
                loading: false,
            };
        case GET_STORES:
            return {
                ...state,
                stores: action.payload,
                count: action.count,
                loading: false,
            };
        case GET_STORES_BY_MAKE:
            return {
                ...state,
                stores: action.payload,
                loading: false,
            };
        case GET_STORE:
            return {
                ...state,
                store: action.payload,
                loading: false,
            };
        case CREATE_STORE:
            return {
                ...state,
                loading: false,
            };
        case DELETE_STORE:
            state.stores = state.stores.filter(
                (store) => store._id.toString() !== action.payload.toString()
            );
            return {
                ...state,
                store: null,
                loading: false,
            };
        case UPDATE_STORE:
            const updatedStore = action.payload as IStore;
            const updatedStores = Array.isArray(action.payload)
                ? state.stores
                : (state.stores || []).map((store: IStore) =>
                      store?._id === updatedStore._id ? updatedStore : store
                  );

            return {
                ...state,
                stores: updatedStores,
                store: action.payload,
                loading: false,
                success: action.successMessage,
            };
        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case CLEAR_STATE:
            return {
                ...state,
                store: {},
                stores: [],
                loading: false,
                error: null,
            };
        case SET_LOADING:
            return {
                ...state,
                loading: true,
            };
        default:
            return state;
    }
};
